module.exports = __webpack_public_path__ + "img/input_orders_active.5ed40e3a.svg";